import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
 
    *,
    *::after,
    *::before {
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        box-sizing: border-box;
        padding: 0;
        margin: 0;
    }

    ul {
        list-style: none;
    }

    li, a {
        text-decoration: none;
        color: ${({ theme }) => theme.text};
    }

    .navbar-mobile-overlay, .card {
        background: ${({ theme }) => theme.cardBg};
    }

    .navbar-mobile-overlay > li, a {
        color: ${({ theme }) => theme.text};
    }

    .drop-shadow {
        box-shadow: ${({ theme }) => theme.cardShadow};
    }

    .stat-card {
        padding: 1.5rem;
        border-radius: 12px;
        box-shadow: ${({ theme }) => theme.cardShadow};
        background: ${({ theme }) => theme.cardBg};
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 4px;
            background: ${({ theme }) => theme.primary};
            transform: scaleX(0);
            transition: transform 0.3s ease;
        }

        &:hover {
            transform: translateY(-4px);
            box-shadow: ${({ theme }) => theme.cardShadowHover};
            
            &::before {
                transform: scaleX(1);
            }
        }

        > h3 {
            font-size: 0.875rem;
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            color: ${({ theme }) => theme.textSecondary};
            margin-bottom: 0.5rem;
        }

        > h1 {
            font-size: 2rem;
            font-weight: 700;
            color: ${({ theme }) => theme.text};
            line-height: 1.2;
        }
    }   

    .button {
        background: ${({ theme }) => theme.primary};
        color: white;
        padding: 0.875rem 2rem;
        margin-top: 0.75rem;
        border: none;
        border-radius: 8px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
            background: ${({ theme }) => theme.secondary};
        }

        &:active {
            transform: translateY(0);
        }
    }

    body {
        background: ${({ theme }) => theme.body};
        color: ${({ theme }) => theme.text};
        min-height: 100vh;
        line-height: 1.6;
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: 700;
        line-height: 1.2;
    }
`;

export const lightTheme = {
    body: '#F5F7FA',
    text: '#1A202C',
    textSecondary: '#4A5568',
    toggleBorder: '#FFF',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    cardBg: '#FFFFFF',
    cardShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    cardShadowHover: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    primary: '#667eea',
    secondary: '#764ba2',
    danger: '#E53E3E',
    success: '#38A169',
    warning: '#D69E2E',
    info: '#3182CE',
};
  
export const darkTheme = {
    body: '#0F172A',
    text: '#F1F5F9',
    textSecondary: '#CBD5E1',
    toggleBorder: '#6B8096',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    cardBg: '#1E293B',
    cardShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)',
    cardShadowHover: '0 20px 25px -5px rgba(0, 0, 0, 0.4), 0 10px 10px -5px rgba(0, 0, 0, 0.3)',
    primary: '#818CF8',
    secondary: '#A78BFA',
    danger: '#F87171',
    success: '#4ADE80',
    warning: '#FBBF24',
    info: '#60A5FA',
};